import React from 'react';

export const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Política de Privacidade</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            <strong>Última atualização:</strong> 18/05/2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introdução</h2>
            <p className="text-gray-700 mb-4">
              A Baruk Automação Inteligente ("nós", "nosso", "nossa") está comprometida em proteger a privacidade e segurança dos dados de nossos clientes. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais e dados corporativos através de nossa plataforma de gestão eletrônica de documentos com inteligência artificial.
            </p>
            <p className="text-gray-700 mb-4">
              Nosso software Know inDoc é projetado para processar, analisar e gerenciar documentos eletrônicos de forma segura e eficiente, utilizando tecnologias de inteligência artificial para otimizar o fluxo de trabalho e a tomada de decisões.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Informações que Coletamos</h2>
            
            <h3 className="text-xl font-medium text-gray-900 mb-3">2.1 Dados de Usuários</h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Nome completo e informações de contato</li>
              <li>Endereço de e-mail e credenciais de acesso</li>
              <li>Informações de perfil e preferências do usuário</li>
              <li>Dados de autenticação e logs de acesso</li>
              <li>Avatar e informações de identificação visual</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">2.2 Dados Corporativos</h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Documentos eletrônicos carregados na plataforma</li>
              <li>Metadados e informações de classificação de documentos</li>
              <li>Dados de análise e insights gerados pela IA</li>
              <li>Configurações de permissões e controle de acesso</li>
              <li>Histórico de atividades e auditoria</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">2.3 Dados Técnicos</h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Endereços IP e informações de dispositivo</li>
              <li>Logs de sistema e dados de performance</li>
              <li>Cookies e tecnologias de rastreamento</li>
              <li>Dados de uso e analytics da plataforma</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Como Usamos Suas Informações</h2>
            
            <h3 className="text-xl font-medium text-gray-900 mb-3">3.1 Funcionalidades Principais</h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Processamento e análise de documentos com IA</li>
              <li>Classificação automática e extração de informações</li>
              <li>Gerenciamento de fluxos de trabalho e aprovações</li>
              <li>Controle de acesso e permissões de usuários</li>
              <li>Geração de relatórios e insights analíticos</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">3.2 Melhorias do Sistema</h3>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Treinamento e aprimoramento dos algoritmos de IA</li>
              <li>Otimização de performance e funcionalidades</li>
              <li>Desenvolvimento de novas funcionalidades</li>
              <li>Análise de uso para melhorar a experiência do usuário</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Compartilhamento de Dados</h2>
            <p className="text-gray-700 mb-4">
              <strong>Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros</strong>, exceto nas seguintes situações:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Com seu consentimento explícito</li>
              <li>Para cumprir obrigações legais ou regulamentares</li>
              <li>Com prestadores de serviços essenciais (hospedagem, segurança)</li>
              <li>Para proteger nossos direitos e segurança</li>
              <li>Em caso de fusão, aquisição ou reestruturação empresarial</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Segurança dos Dados</h2>
            <p className="text-gray-700 mb-4">
              Implementamos medidas de segurança robustas para proteger seus dados:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Criptografia de dados em repouso e em trânsito</li>
              <li>Controle de acesso baseado em roles (RBAC)</li>
              <li>Monitoramento contínuo de segurança</li>
              <li>Backups regulares e redundância de dados</li>
              <li>Conformidade com padrões de segurança (ISO 27001)</li>
              <li>Auditoria regular de segurança</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Retenção de Dados</h2>
            <p className="text-gray-700 mb-4">
              Mantemos seus dados pelo tempo necessário para:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Fornecer nossos serviços conforme contratado</li>
              <li>Cumprir obrigações legais e regulamentares</li>
              <li>Resolver disputas e fazer cumprir nossos acordos</li>
              <li>Melhorar nossos serviços e funcionalidades</li>
            </ul>
            <p className="text-gray-700 mb-4">
              Dados são excluídos automaticamente após o período de retenção ou mediante solicitação do cliente.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Seus Direitos</h2>
            <p className="text-gray-700 mb-4">
              Você tem os seguintes direitos relacionados aos seus dados:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li><strong>Acesso:</strong> Solicitar informações sobre dados coletados</li>
              <li><strong>Correção:</strong> Atualizar ou corrigir dados imprecisos</li>
              <li><strong>Exclusão:</strong> Solicitar a remoção de dados pessoais</li>
              <li><strong>Portabilidade:</strong> Receber dados em formato estruturado</li>
              <li><strong>Oposição:</strong> Opor-se ao processamento de dados</li>
              <li><strong>Restrição:</strong> Limitar o processamento de dados</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Inteligência Artificial</h2>
            <p className="text-gray-700 mb-4">
              Nossa plataforma utiliza tecnologias de inteligência artificial para:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Processamento e análise automática de documentos</li>
              <li>Classificação e categorização inteligente</li>
              <li>Extração de informações e dados estruturados</li>
              <li>Detecção de padrões e anomalias</li>
              <li>Automação de fluxos de trabalho</li>
            </ul>
            <p className="text-gray-700 mb-4">
              Os algoritmos de IA são treinados com dados anonimizados e não identificam indivíduos específicos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Cookies e Tecnologias Similares</h2>
            <p className="text-gray-700 mb-4">
              Utilizamos cookies e tecnologias similares para:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Manter sessões de usuário e autenticação</li>
              <li>Lembrar preferências e configurações</li>
              <li>Analisar uso da plataforma e melhorar funcionalidades</li>
              <li>Garantir segurança e prevenir fraudes</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Transferências Internacionais</h2>
            <p className="text-gray-700 mb-4">
              Seus dados podem ser processados em servidores localizados fora do Brasil. Garantimos que todas as transferências internacionais seguem padrões adequados de proteção de dados e são realizadas em conformidade com a legislação aplicável.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Alterações na Política</h2>
            <p className="text-gray-700 mb-4">
              Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre mudanças significativas através de:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Notificação por e-mail aos usuários registrados</li>
              <li>Aviso na plataforma com destaque</li>
              <li>Atualização da data de "Última atualização"</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Contato</h2>
            <p className="text-gray-700 mb-4">
              Para questões relacionadas a esta Política de Privacidade ou sobre o tratamento de seus dados pessoais, entre em contato conosco:
            </p>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-medium text-gray-900 mb-3">Suporte Técnico</h3>
              <p className="text-gray-700 mb-2">
                <strong>E-mail:</strong> <a href="mailto:suporte@baruk.ai" className="text-blue-600 hover:text-blue-800">suporte@baruk.ai</a>
              </p>
              <p className="text-gray-700 mb-4">
                Para questões relacionadas à parte técnica da solução, problemas de acesso, funcionalidades da plataforma e suporte geral.
              </p>

              <h3 className="text-lg font-medium text-gray-900 mb-3">Privacidade e Dados</h3>
              <p className="text-gray-700 mb-2">
                <strong>E-mail:</strong> <a href="mailto:falecom@baruk.com" className="text-blue-600 hover:text-blue-800">falecom@baruk.com</a>
              </p>
              <p className="text-gray-700 mb-4">
                Para questões sobre privacidade, tratamento de dados pessoais, solicitações de direitos do titular de dados e assuntos relacionados à proteção de dados.
              </p>

              <h3 className="text-lg font-medium text-gray-900 mb-3">Baruk Automação Inteligente</h3>
              <p className="text-gray-700">
                <strong>Endereço:</strong> São Paulo, SP, Brasil<br/>
                <strong>Website:</strong> <a href="https://www.baruk.ai" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">www.baruk.ai</a>
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Conformidade Legal</h2>
            <p className="text-gray-700 mb-4">
              Esta Política de Privacidade está em conformidade com:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700">
              <li>Lei Geral de Proteção de Dados (LGPD) - Lei nº 13.709/2018</li>
              <li>Marco Civil da Internet - Lei nº 12.965/2014</li>
              <li>Regulamentações específicas do setor</li>
              <li>Padrões internacionais de proteção de dados</li>
            </ul>
          </section>

          <div className="border-t pt-6 mt-8">
            <p className="text-sm text-gray-500 text-center">
              © {new Date().getFullYear()} Baruk Automação Inteligente. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}; 